import React from "react";
import { useTranslation } from "react-i18next";
import Delete from "../../common/delete";
import Edit from "../../common/edit";
import MatTable from "../../common/matTable";
import { formatToDate } from "../../common/dateUtil";

const ClassSectionTable = ({ data, sortColumn, onSort, onDelete }) => {
  const { t } = useTranslation(["admissionCalendar","common"]);
  const columns = [
    // { path: "id", label: t("ID") },

    { path: "programName", label: t("common:Program") },
    { path: "name", label: t("Section")},
    {
      key: "action",
      content: (item) => {
        return <><Edit link={`class-sections/${item.id}`} /> &nbsp; <Delete onDelete={onDelete} item={item} /></>;
      },
    }
  ];

  return (
    <MatTable
      data={data}
      heading="List of Sections"
      columns={columns}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default ClassSectionTable;
